module.exports = __webpack_public_path__ + "media/images/empty_posts-d537310846df6e5c1f6b60a1a7dd69c1.png";